import React from 'react';
import { StyleSheet, Pressable } from 'react-native';
import { YStack } from '@tamagui/stacks';
import { Lock } from 'lucide-react-native';
import { COLORS } from '@/constants/colors';
import { ICON_SIZE_XLARGE, PHOTO_BORDER_RADIUS, LOCKED_PHOTO_HEIGHT } from '../constants';
import AuthenticatedImage from '@/components/AuthenticatedImage';

type LockedPhotoProps = {
  imageUri: string;
  onPress: () => void;
  isDark?: boolean;
};

const LockedPhoto = React.memo<LockedPhotoProps>(({ imageUri, onPress, isDark }) => {
  const containerBg = isDark ? COLORS.ZINC_900 : COLORS.ZINC_200;
  const overlayBg = isDark ? 'rgba(0, 0, 0, 0.7)' : COLORS.WHITE_90;
  const iconColor = isDark ? COLORS.WHITE : COLORS.ZINC_900;
  
  const containerStyle = StyleSheet.create({
    container: {
      position: 'relative',
      borderRadius: PHOTO_BORDER_RADIUS,
      overflow: 'hidden',
      backgroundColor: containerBg,
    },
    image: {
      width: '100%',
      height: LOCKED_PHOTO_HEIGHT,
    },
    overlay: {
      position: 'absolute',
      opacity: 0.8,
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      backgroundColor: overlayBg,
      alignItems: 'center',
      justifyContent: 'center',
    },
  });
  
  return (
    <Pressable onPress={onPress}>
      <YStack style={containerStyle.container}>
        <YStack>
          <AuthenticatedImage 
            uri={imageUri}
            style={containerStyle.image}
            resizeMode="cover"
          />
        </YStack>
        <YStack style={containerStyle.overlay}>
          <Lock size={ICON_SIZE_XLARGE} color={iconColor} />
        </YStack>
      </YStack>
    </Pressable>
  );
});

LockedPhoto.displayName = 'LockedPhoto';

export default LockedPhoto;

